"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERMS_AND_CONDITIONS_LINKS = void 0;
exports.TERMS_AND_CONDITIONS_LINKS = [
    {
        key: 'privacy-statement',
        text: 'Privacy Statement',
    },
    {
        key: 'cookie-statement',
        text: 'Cookie Statement',
    },
    {
        key: 'terms-of-use',
        text: 'Terms of Use',
    },
];
